import _ from 'lodash'

function escapePreserveLineBreaks(text) {
	// #30822 handle 0 appropriately instead of as a falsy value
	// _.toString will return '' if text is null
	text = _.toString(text)
	text = _.escape(text)
	text = text.split(/\r?\n|\r/g).join('<br>')
	return text
}

export default escapePreserveLineBreaks

escapePreserveLineBreaks.__filename__ = 'components/escape-preserve-line-breaks.js'
